import { Suspense, lazy } from "react";
import "./skills.css";

import javascript from "../../images/icons/javascript.png";
import typescript from "../../images/icons/typescript.png";
import html from "../../images/icons/html.png";
import css from "../../images/icons/css.png";
import reactjs from "../../images/icons/reactjs.png";
import tailwind from "../../images/icons/tailwind.png";
import nodejs from "../../images/icons/nodejs.png";
import git from "../../images/icons/git.png";
import figma from "../../images/icons/figma.png";
import docker from "../../images/icons/docker.png";
import postgresql from "../../images/icons/postgresql.png";
import graphql from "../../images/icons/graphql.png";

const BallCanvas = lazy(() => import("../../hooks/ballCanvas"));

const SkillSkeleton = ({ name }) => (
  <div className="skill-skeleton" role="img" aria-label={`Carregando ${name}`}>
    <span className="skill-skeleton__pulse" aria-hidden="true" />
  </div>
);

export default function Skills() {
  const technologies = [
    {
      name: "HTML 5",
      icon: html,
    },
    {
      name: "CSS 3",
      icon: css,
    },
    {
      name: "JavaScript",
      icon: javascript,
    },
    {
      name: "TypeScript",
      icon: typescript,
    },
    {
      name: "React JS",
      icon: reactjs,
    },
    {
      name: "Node JS",
      icon: nodejs,
    },
    {
      name: "Tailwind CSS",
      icon: tailwind,
    },
    {
      name: "graphql",
      icon: graphql,
    },
    {
      name: "postgresql",
      icon: postgresql,
    },
    {
      name: "git",
      icon: git,
    },
    {
      name: "figma",
      icon: figma,
    },
    {
      name: "docker",
      icon: docker,
    },
  ];

  return (
    <section id="skills" className="s-skills row target-section" data-aos="fade-up">
      <header className="section-header">
        <span className="section-eyebrow">Competências principais</span>
        <h2 className="section-title">Skills</h2>
        <p className="section-subtitle">
          Ferramentas, linguagens e plataformas que utilizo no dia a dia para construir experiências digitais completas.
        </p>
      </header>
      <div className="skills-grid" aria-live="polite">
        {technologies.map((technology, index) => (
          <div className="skill-item" key={technology.name}>
            <Suspense fallback={<SkillSkeleton name={technology.name} />}>
              <BallCanvas icon={technology.icon} index={index} />
            </Suspense>
          </div>
        ))}
      </div>
    </section>
  );
}
